import { c as _c } from "react/compiler-runtime";
import { BodyLong, Button, Checkbox, ErrorSummary, HStack, VStack } from "@navikt/ds-react";
// Flat imports are required because compound imports break with optimizePackageImports.
import { ExpansionCard, ExpansionCardContent, ExpansionCardHeader, ExpansionCardTitle } from "@navikt/ds-react/ExpansionCard";
import { List, ListItem } from "@navikt/ds-react/List";
import { useEffect, useRef, useState } from "react";
import { FetchErrorAlert } from "@/ui/FetchErrorAlert";
import useMeldUnntakAction from "./useMeldUnntakAction";
const BEKREFTELSE_CHECKBOX_ID = "meld-unntak-bekreftelse";
interface Props {
  ansattNavn: string;
  onSuccess: () => void;
}
export default function MeldUnntakForm(t0) {
  const $ = _c(33);
  const {
    ansattNavn,
    onSuccess
  } = t0;
  const [erBekreftet, setErBekreftet] = useState(false);
  const [visValideringsfeil, setVisValideringsfeil] = useState(false);
  const errorSummaryRef = useRef(null);
  const {
    error,
    isPending,
    meldUnntak
  } = useMeldUnntakAction();
  let t1;
  let t2;
  if ($[0] !== visValideringsfeil) {
    t1 = () => {
      if (visValideringsfeil) {
        errorSummaryRef.current?.focus();
      }
    };
    t2 = [visValideringsfeil];
    $[0] = visValideringsfeil;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== erBekreftet || $[4] !== meldUnntak || $[5] !== onSuccess || $[6] !== visValideringsfeil) {
    t3 = function handleSubmit(event) {
      event.preventDefault();
      if (!erBekreftet) {
        if (visValideringsfeil) {
          errorSummaryRef.current?.focus();
        } else {
          setVisValideringsfeil(true);
        }
        return;
      }
      meldUnntak(onSuccess);
    };
    $[3] = erBekreftet;
    $[4] = meldUnntak;
    $[5] = onSuccess;
    $[6] = visValideringsfeil;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSubmit = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function handleBekreftelseChange(event_0) {
      setErBekreftet(event_0.target.checked);
      if (event_0.target.checked) {
        setVisValideringsfeil(false);
      }
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleBekreftelseChange = t4;
  const t5 = `Unntak fra oppfølgingsplan for ${ansattNavn}`;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ExpansionCardHeader><ExpansionCardTitle as="h3" size="small">Det finnes noen unntak fra å lage oppfølgingsplan</ExpansionCardTitle></ExpansionCardHeader>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <BodyLong>Disse kan for eksempel være:</BodyLong>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <VStack gap="space-8">{t7}<List><ListItem>Alvorlig sykdom gjør at den ansatte ikke klarer å lage en plan</ListItem><ListItem>Den ansatte er snart tilbake i full jobb</ListItem><ListItem>Arbeidsforholdet skal snart avsluttes</ListItem><ListItem>Det er ikke mulig å få kontakt med den ansatte</ListItem></List></VStack>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== visValideringsfeil) {
    t9 = visValideringsfeil && <ErrorSummary ref={errorSummaryRef} heading={"Du m\xE5 rette dette f\xF8r du kan sende:"}><ErrorSummary.Item href={`#${BEKREFTELSE_CHECKBOX_ID}`}>Du må bekrefte at en oppfølgingsplan ikke er nødvendig nå</ErrorSummary.Item></ErrorSummary>;
    $[12] = visValideringsfeil;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== ansattNavn || $[15] !== erBekreftet || $[16] !== visValideringsfeil) {
    t10 = <Checkbox id={BEKREFTELSE_CHECKBOX_ID} checked={erBekreftet} onChange={handleBekreftelseChange} error={visValideringsfeil} description={"Unntakene f\xF8lger av arbeidsmilj\xF8loven \xA7 4-6: Planen kan utelates \xABmed mindre det er \xE5penbart un\xF8dvendig\xBB."}>Jeg bekrefter at en oppfølgingsplan ikke er nødvendig for{" "}{ansattNavn} slik situasjonen er nå.</Checkbox>;
    $[14] = ansattNavn;
    $[15] = erBekreftet;
    $[16] = visValideringsfeil;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== error) {
    t11 = <FetchErrorAlert error={error} />;
    $[18] = error;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isPending) {
    t12 = <HStack><Button type="submit" variant="primary" data-color="neutral" size="small" loading={isPending}>Send til Nav og den ansatte</Button></HStack>;
    $[20] = isPending;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9) {
    t13 = <VStack gap="space-16">{t8}{t9}{t10}{t11}{t12}</VStack>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== handleSubmit || $[28] !== t13) {
    t14 = <ExpansionCardContent><form onSubmit={handleSubmit} noValidate={true}>{t13}</form></ExpansionCardContent>;
    $[27] = handleSubmit;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t5) {
    t15 = <ExpansionCard aria-label={t5} data-color="neutral" size="small">{t6}{t14}</ExpansionCard>;
    $[30] = t14;
    $[31] = t5;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}